import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { App } from './app/App';
import { setupGlobalErrorHandlers } from './shared/lib/logger';
import { setupSessionExpiryResetOnPageRestore } from './shared/lib/sessionExpiry';

// グローバルエラーハンドラーを設定
setupGlobalErrorHandlers();
setupSessionExpiryResetOnPageRestore();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(<App />);
